const gendersText = new Map([
  ["FEMALE", "Female"],
  ["MALE", "Male"],
  ["NON_BINARY", "Non-binary/non-conforming"],
  ["PREFER_NOT_TO_SAY", "Prefer not to respond"],
  ["TRANSGENDER", "Transgender"],
]);

// https://fontawesome.com/search?o=r&c=gender
export const genderIcons = new Map([
  ["FEMALE", "venus"],
  ["MALE", "mars"],
  ["NON_BINARY", "mercury"],
  ["PREFER_NOT_TO_SAY", null],
  ["TRANSGENDER", "transgender"],
]);

/**
 * @param {Gender} gender
 */
export const genderIcon = (gender) => {
  return genderIcons.get(gender);
};

export default gendersText;
